export const authScreens = {
  accesoDirecto: {
    loading: "Anmeldung bei Ihrem Konto…",
  },
  confirmar: {
    verifying: "Konto wird überprüft…",
    verifiedSuccess: "Konto erfolgreich bestätigt",
    tokenInvalid: "Der Token existiert nicht oder ist bereits abgelaufen",
    backHome: "Zurück zum Start",
  },
  recovery: {
    title: "Passwort zurücksetzen",
    successTitle: "Geschafft!",
    successDesc:
      "Ihr Passwort wurde erfolgreich geändert. Sie werden zum Start weitergeleitet…",
    infoTitle: "Neues Passwort erstellen",
    infoDesc:
      "Durch die Änderung werden alle aktiven Sitzungen auf Ihren anderen Geräten abgemeldet.",
    newPasswordLabel: "Neues Passwort",
    newPasswordPlaceholder: "Neues Passwort eingeben",
    togglePasswordAria: "Passwort ein-/ausblenden",
    confirmPasswordLabel: "Passwort wiederholen",
    confirmPasswordPlaceholder: "Neues Passwort wiederholen",
    passwordsMismatch: "Die Passwörter stimmen nicht überein.",
    submit: "Passwort ändern",
    submitting: "Wird verarbeitet…",
    backToStart: "Zurück zum Start",
    footerWeb: "Website",
    toastInvalidLink: "Der Wiederherstellungslink ist ungültig oder abgelaufen.",
    errorGeneric: "Das Passwort konnte nicht geändert werden.",
  },
};
